<template>
  <div id="index">
    <img src="@/assets/top.png" class="top" />
    <div class="nav">
      <div class="left">
        <van-icon name="arrow-left" size="20" />
      </div>

      <div class="center">
        <img src="@/assets/logo.png" width="21" height="25" style="margin-top:6px" />
        <span style="margin-left:0.3rem">青山湖区智慧残联</span>
      </div>
      <div class="right" @click="toUrl('/mine')">
        <van-icon name="manager" size="21" />
      </div>
    </div>
    <div class="padding">
      <van-swipe :autoplay="4000" indicator-color="#80BE61">
        <van-swipe-item v-for="(image, index) in images" :key="index">
          <img src="@/assets/banner1.png" style="width:100%" />
        </van-swipe-item>
      </van-swipe>
      <div class="tips">
        <div class="tips-left">公告栏目</div>
        <div class="tips-center">
          <ul id="con1" ref="con1" :class="{anim:animate==true}">
            <van-loading v-show="showL" type="spinner" />
            <li
              v-for="(item,index) in items"
              :key="index"
              @click="toInfo(item.id,1,item.url)"
            >{{item.title}}</li>
          </ul>
        </div>
        <div class="tips-right" @click="toUrl('/notice')">
          <div>更多</div>
          <van-icon name="arrow" size="16" />
        </div>
      </div>
      <div class="icons">
        <div class="icon" @click="toUrl('/intro')">
          <img src="@/assets/index-icon1.png" />
          <div>概况简介</div>
        </div>
        <div class="icon" @click="toUrl('/venue')">
          <img src="@/assets/index-icon2.png" />
          <div>场馆预约</div>
        </div>
        <div class="icon">
          <img src="@/assets/index-icon3.png" @click="toUrl('/help')" />
          <div>我想帮</div>
        </div>
        <div class="icon" @click="toUrl('/want')">
          <img src="@/assets/index-icon4.png" />
          <div>我想要</div>
        </div>
      </div>
      <div class="notice">
        <div class="notice-tit">
          <div class="notice-tit-text">活动动态</div>
          <div class="notice-tit-more" @click="toUrl('/news')">更多</div>
          <div class="more-icon">
            <van-icon name="arrow" size="18" />
          </div>
        </div>
        <div class="notice-lists">
          <van-loading size="24px" v-show="showG">加载中...</van-loading>
          <div
            class="notice-list"
            v-for="(item,index) in list"
            :key="index"
            @click="toInfo(item.id,1,item.url)"
          >
            <div class="list-tit">
              {{item.title}}
              <div class="eye-div" style="color:#C8C8C8;display:flex">
                <van-icon name="eye-o" size="16" color="#C8C8C8" />
                <span>{{item.view}}</span>
              </div>
            </div>
            <div class="list-icon">
              <img src="@/assets/index.png" v-if="item.cover==''" />
              <img :src="item.cover" v-else />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Swipe, SwipeItem, Loading, Toast } from "vant";
import { article, articleGs, view,  getTokenByTicket, toknStatus} from "@/api/apiData";
export default {
  components: {
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Loading.name]: Loading,
  },
  data() {
    return {
      images: ["@/assets/banner1.png", "@/assets/banner1.png"],
      animate: false,
      items: [],
      list: [],
      showL: true,
      showG: true,
      // chatUrl:"https://qshcjr.ncscloudmedia.com/api.php"
      // chatUrl:"http://cjr.cn/api.php"
    };
  },
  created() {
    setInterval(this.scroll, 2000);
  },
  mounted() {
    // let ticket = this.$route.query.ticket;
    // let token = localStorage.getItem("tokenY");
    //       // localStorage.setItem("tokenY", 44);
    // if (ticket) {
    //   this.ticket = ticket;
    //   this.getTokenByTickets();
    //   this.$router.push("/index");
    // } else if (token) {
    //   this.token = token;
    //   this.IsTokenStatus(token);
    // } else {
    //   var href = escape(window.location.href);
    //   var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
    //   window.location.href = url;
    // }
    this.getList();
    this.getList2();
  },
  methods: {
    //    // 获取token
    // getTokenByTickets() {
    //   //  alert(this.ticket)
    //   getTokenByTicket({ ticket: this.ticket }).then((res) => {
    //     if (res.status == 1) {
    //       localStorage.setItem("tokenY", res.data.token);
    //       this.token = res.data.token;
    //     } else {
    //       this.$router.push("/index");
    //       var href = escape(window.location.href);
    //       var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
    //       window.location.href = url;
    //     }
    //   });
    // },
    // // token是否失效
    // IsTokenStatus(token) {
    //   toknStatus({ token: token }).then((res) => {
    //     if (res.status == 1) {
    //       this.token = token;
    //     } else {
    //       var href = escape(window.location.href);
    //       var url = this.chatUrl + "/OAuth/wxLogin?url=" + href;
    //   // alert(url)
    //       window.location.href = url;
    //     }
    //   });
    // },
    scroll() {
      this.animate = true; // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
      setTimeout(() => {
        //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
        this.items.push(this.items[0]); // 将数组的第一个元素添加到数组的
        this.items.shift(); //删除数组的第一个元素
        this.animate = false; // margin-top 为0 的时候取消过渡动画，实现无缝滚动
      }, 500);
    },
    toUrl(u) {
      this.$router.push(u);
    },
    getList() {
      article({ catid: 28 }).then((res) => {
        if (res.status == 1) {
          this.list = res.data.data;
          this.showL = false;
        } else {
          Toast(res.message);
        }
      });
    },
    getList2() {
      articleGs().then((res) => {
        if (res.status == 1) {
          this.items = res.data.data;
          this.showG = false;
        } else {
          Toast(res.message);
        }
      });
    },
    toInfo(id, t, url) {
      // console.log(888)
      view({ id: id }).then((res) => {});
      if (url == "") {
        this.$router.push({
          path: "/noticeInfo",
          query: {
            id: id,
            type: t,
          },
        });
      } else {
        window.location.href = url;
      }
    },
  },
};
</script>
<style scoped>
.anim {
  transition: all 0.5s;
  margin-top: -2.5rem;
}
#con1 li {
  /* list-style: none;
  height: 2.2rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden; */
  list-style: none;
  line-height: 2.5rem;
  height: 2.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tips {
  display: flex;
  font-size: 0.8rem;
  /* width: 95%; */
  /* margin: 0 auto; */
  /* padding: 1rem; */
  margin: 0.5rem;
  background: white;
  padding: 0.8rem 0.5rem;
  box-shadow: 0px 0px 8px 0px gainsboro;
  border-radius: 5px;
  height: 2.5rem;
}
.tips-left {
  width: 2rem;
  height: 2rem;
  background: #f8e4e3;
  color: #d2301f;
  border: solid 1px #d2301f;
  border-radius: 3rem;
  padding: 0.3rem;
  font-weight: bold;
  font-size: 0.7rem;
}
.tips-center {
  color: #000000;
  font-weight: bold;
  text-align: left;
  width: 70%;
  margin-left: 3%;
  padding: 0.2rem;
  overflow: hidden;
  /* text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; */
}
.tips-right {
  /* padding-top: 0.5rem; */
  color: #d2301f;
  display: flex;
  width: 3rem;
  align-self: center;
  align-content: center;
  align-items: center;
}
.icons {
  display: flex;
  margin-top: 1.3rem;
}
.icon {
  flex: 1;
  padding: 0.5rem;
  text-align: center;
  font-size: 0.9rem;
}
.icon img {
  width: 3rem;
  height: 3rem;
}
.notice {
  border-top: solid 4px #f5f5f5;
  margin-top: 1.3rem;
  /* margin-bottom: 1.5rem; */
  padding-top: 1.3rem;
  padding-left: 1.2rem;
  padding-right: 1.2rem;
}
.notice-tit {
  display: flex;
}
.notice-tit-more {
  /* display: flex; */
  width: 20%;
  color: #ababab;
  text-align: right;
  align-self: center;
  font-size: 0.8rem;
}
.more-icon {
  color: #ababab;
  padding-top: 5px;
}
.notice-tit-text {
  font-size: 1.2rem;
  font-weight: bold;
  width: 80%;
  text-align: left;
  position: relative;
}
.notice-tit-text:after {
  content: "";
  /* margin: 0 auto; */
  position: absolute;
  bottom: -14rpx;
  left: 0.7rem;
  /* right: 0; */
  height: 6px;
  width: 2.5rem;
  background-color: #79ca50;
  bottom: 0px;
  z-index: -1;
  border-radius: 5px;
}
.notice-lists {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.notice-list {
  display: flex;
  font-size: 0.9rem;
  /* border: solid 1px #C1C1C1; */
  box-shadow: 0px 0px 3px 0px rgb(193 193 193 / 54%);
  padding: 0.5rem;
  overflow: hidden;
  height: 5rem;
}
.list-tit {
  width: 65%;
  text-align: left;
  color: black;
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  position: relative;
}
.list-icon {
  width: 35%;
  text-align: right;
}
.list-icon img {
  width: 100%;
  height: 100%;
  margin-left: 1rem;
}
.eye-div {
  color: rgb(200, 200, 200);
  display: flex;
  position: absolute;
  bottom: 0;
}
.eye-div span {
  line-height: 1.2rem;
  margin-left: 0.2rem;
  font-size: 0.6rem;
}
</style>


// WEBPACK FOOTER //
// src/page/index.vue